import { ReactNode } from 'react';
import { Card as ReactstrapCard, CardBody as ReactstrapCardBody, CardProps, CardBodyProps } from 'reactstrap';
import classNames from 'classnames';
import './styles.scss';

type ShadowSize = 'none' | 'sm' | 'md' | 'lg';

interface AtomCardProps extends Omit<CardProps, 'className'> {
  children: ReactNode;
  className?: string;
  /** Enable hover effect (background color change). Default: false */
  hover?: boolean;
  /** Shadow size. Default: 'sm' */
  shadow?: ShadowSize;
}

interface AtomCardBodyProps extends Omit<CardBodyProps, 'className'> {
  children: ReactNode;
  className?: string;
}

/**
 * Card component with configurable hover and shadow effects.
 *
 * By default, hover is disabled and shadow is 'sm'.
 * Use `hover={true}` to enable the hover background effect.
 */
export const Card = ({
  children,
  className,
  hover = true,
  shadow = 'sm',
  ...props
}: AtomCardProps) => {
  const shadowClasses: Record<ShadowSize, string> = {
    none: '',
    sm: 'shadow-sm',
    md: 'shadow-md',
    lg: 'shadow-lg',
  };

  return (
    <ReactstrapCard
      className={classNames(
        'atom-card',
        hover ? 'shadow-hover-xl' : '',
        shadowClasses[shadow],
        className
      )}
      {...props}
    >
      {children}
    </ReactstrapCard>
  );
};

export const CardBody = ({ children, className, ...props }: AtomCardBodyProps) => {
  return (
    <ReactstrapCardBody className={className} {...props}>
      {children}
    </ReactstrapCardBody>
  );
};
